<script>
    import { navigateTo } from 'svelte-router-spa'
    import { idNumber } from '../../store.js'

    function nxt() {
        idNumber.set($idNumber)
        navigateTo('department')
    }
</script>

<main>
    <div class="body">
        <h1>Enter your ID Number</h1>
        <p>Ilagay ang iyong ID Number</p>
        <input type="text" bind:value={$idNumber}>

        {#if $idNumber}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>